// extracted by mini-css-extract-plugin
export default {"bg-dark":"Footer_bg-dark__c40hR","footer":"Footer_footer__WFmHU","btn":"Footer_btn__nggBA","btn-link":"Footer_btn-link__2VKPq","bottom_footer":"Footer_bottom_footer__AyTW5"};